import React, {forwardRef} from 'react';
const ComponentToPrint = forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      <pre className="previewData">{props.configData?.data || ''}</pre>
    </div>
  );
});

ComponentToPrint.displayName = 'ComponentToPrint';
export default ComponentToPrint;
